import { render, staticRenderFns } from "./UserBind.vue?vue&type=template&id=68b31692&scoped=true&"
import script from "./UserBind.vue?vue&type=script&lang=js&"
export * from "./UserBind.vue?vue&type=script&lang=js&"
import style0 from "./UserBind.vue?vue&type=style&index=0&id=68b31692&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b31692",
  null
  
)

export default component.exports